// src/utils/shuffle.js
// Prosta, niemutująca implementacja tasowania Fisher–Yates

export function shuffle(array) {
  const result = array.slice(); // nie modyfikujemy oryginału

  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = result[i];
    result[i] = result[j];
    result[j] = tmp;
  }

  return result;
}

// opcjonalnie, jeśli kiedyś chciałbyś używać import shuffle from "..."
export default shuffle;
